export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Click to select which columns to display"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Displayed Columns"])}
}